import { render, staticRenderFns } from "./IntegrationRequests.vue?vue&type=template&id=4547a0a0&scoped=true&"
import script from "./IntegrationRequests.vue?vue&type=script&lang=js&"
export * from "./IntegrationRequests.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationRequests.vue?vue&type=style&index=0&id=4547a0a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4547a0a0",
  null
  
)

export default component.exports